import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Alert": Alert, "@mui/material/IconButton": IconButton, "@mui/material/Collapse": Collapse, "@mui/material/Button": Button, "@mui/icons-material/Close": CloseIcon } } });
export default ClientProvider;
